import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/odds-converter',
  component: () => import('../../routes/OddsConverter.svelte'),
  card: {
    id: 'odds-converter',
    title: 'Odds Converter',
    description: 'Convert between decimal, American, and fractional odds with implied probability calculation.',
    icon: 'swap_horiz',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/odds-converter',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Odds Converter – Decimal, American & Fractional Odds Calculator',
    description: 'Free odds converter tool. Convert decimal, American (moneyline), and fractional odds instantly. Shows implied probability and underdog/favorite classification for each odds format.',
  },
};

export default meta;
